<template>
  <div class="chat-window">
    <div class="chat-header">
      <h3>Mensagens</h3>
      <button @click="$emit('close')" class="close-btn">×</button>
    </div>

    <div class="chat-body">
      <chat-room-list v-if="!activeRoomId" @select="selectRoom" />
      <chat-room v-else :roomId="activeRoomId" @back="backToList" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChatRoomList from './ChatRoomList.vue'
import ChatRoom from './ChatRoom.vue'

export default {
  name: 'ChatWindow',
  components: { ChatRoomList, ChatRoom },
  computed: {
    ...mapGetters('chatPlugin', ['activeRoomId'])
  },
  methods: {
    ...mapActions('chatPlugin', ['selectRoom']),
    backToList () {
      this.$store.commit('chatPlugin/SET_ACTIVE_ROOM', null)
    }
  }
}
</script>

<style scoped>
.chat-window { position: fixed; bottom: 90px; right: 20px; width: 380px; height: 500px; background: white; border-radius: 12px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; overflow: hidden; }
.chat-header { background: linear-gradient(135deg, #9c27b0 0%, #673ab7 100%); color: white; padding: 16px; display: flex; justify-content: space-between; align-items: center; }
.chat-header h3 { margin: 0; font-size: 18px; font-weight: 600; }
.close-btn { background: none; border: none; color: white; font-size: 32px; cursor: pointer; padding: 0; width: 32px; height: 32px; line-height: 1; }
.chat-body { flex: 1; overflow: hidden; }
@media (max-width: 768px) {
  .chat-window { bottom: 0; right: 0; left: 0; width: 100%; height: 100%; max-height: 100vh; border-radius: 0; }
}
</style>



// WEBPACK FOOTER //
// ChatWindow.vue?11b4a33a